<script lang="ts" setup>
const t2 = useT2({})
export type NavTypes = 'user' | 'info'
const auth = useAuth()
defineProps<{ active: NavTypes }>()
</script>

<template>
  <AppSideMenuRoll :options="auth.isAuth ? ['user', 'info'] : ['info']" :start="auth.isAuth ? active : 'info'">
    <template #default="{ show }">
      <AppSideMenuInfo v-if="show === 'info'" profile />
      <AppSideMenuUser v-if="show === 'user'" />
    </template>

    <template v-if="auth.isAuth" #button="{ show, toNext }">
      <ButtonUi2 max-width r9 :txt="show === 'user' ? t2('User') : t2('Customer Care')" :on="false" @click="toNext()">
        <IconArrowUp down class="_svg16 _mr14" />
      </ButtonUi2>
    </template>
  </AppSideMenuRoll>
</template>
